/**
 * Brandwatch API Hooks
 */

import { useApiData, useAuthenticatedFetch } from './client';
import type { BrandwatchProject, BrandwatchQuery, BrandwatchMention, BrandwatchSource } from './types';

export function useBrandwatchProjects() {
  return useApiData<BrandwatchProject[]>('/internal/datasources/brandwatch/projects');
}

export function useBrandwatchQueries(bwProjectId: number | undefined) {
  const endpoint = bwProjectId
    ? `/internal/datasources/brandwatch/queries/${bwProjectId}`
    : null;
  return useApiData<BrandwatchQuery[]>(endpoint || '/internal/datasources/brandwatch/queries/0');
}

export function useBrandwatchSources(projectId: number | undefined) {
  const endpoint = projectId ? `/internal/datasources/brandwatch/${projectId}` : null;
  return useApiData<BrandwatchSource[]>(endpoint || '/internal/datasources/brandwatch/0');
}

export function useBrandwatchMutations() {
  const { fetchData: fetchSample } = useAuthenticatedFetch<{ mentions: BrandwatchMention[] }>();
  const { fetchData: fetchRegister } = useAuthenticatedFetch<BrandwatchSource>();

  const sample = (data: {
    bw_project_id: number;
    bw_query_id: number;
    date_range_start?: string;
    date_range_end?: string;
  }) =>
    fetchSample('/internal/datasources/brandwatch/sample', {
      method: 'POST',
      body: JSON.stringify(data),
    });

  const register = (data: {
    id_project: number;
    bw_project_id: number;
    bw_project_name: string;
    bw_query_id: number;
    bw_query_name: string;
    hydrate_tweets: boolean;
  }) =>
    fetchRegister('/internal/datasources/brandwatch/register', {
      method: 'POST',
      body: JSON.stringify(data),
    });

  return { sample, register };
}
